export default "__VITE_ASSET__d2TuerRJ__"